export const userFundActivityStatuses = {
  IsEnabled: (x) => (typeof x === 'string' ? x === 'ENABLED' : x.id === 'ENABLED'),
  IsHalfEnabled: (x) => (typeof x === 'string' ? x === 'HALFENABLED' : x.id === 'HALFENABLED'),
  IsDisabled: (x) => (typeof x === 'string' ? x === 'DISABLED' : x.id === 'DISABLED'),
  list: [
    {
      id: 'ENABLED',
      title: 'enabled',
    },
    {
      id: 'DISABLED',
      title: 'disabled',
    },
    {
      id: 'HALFENABLED',
      title: 'half-enabled',
    },
  ],
};
